import React from 'react';
import { YouTubeSocialCircle } from 'components/SocialCircle';
import SocialButton, { SocialButtonProps } from './SocialButton';

export interface YouTubeButtonProps
  extends Pick<
    SocialButtonProps,
    'disabled' | 'onClick' | 'params' | 'size' | 'tooltip'
  > {}

const YouTubeButton: React.FC<YouTubeButtonProps> = ({
  disabled,
  onClick,
  size,
  tooltip,
}) => (
  <SocialButton
    icon={<YouTubeSocialCircle className="white-background" />}
    label="YouTube"
    {...{ disabled, onClick, size, tooltip }}
  />
);

export default YouTubeButton;
